/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractResourceService, JsonApiResource } from '@irian-ro/abstract-resource';
import { CustomerProfileDTO } from '@well/domain';
import {EnvironmentService} from "@irian-ro/util-environment";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CustomerProfileResourceService extends AbstractResourceService<
  CustomerProfileDTO,
  CustomerProfileDTO,
  any,
  any
> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('customerProfileUrl'),
      CustomerProfileDTO,
      CustomerProfileDTO
    );
  }

  findOneByCustomerUuid(customerUuid: any): Observable<JsonApiResource<CustomerProfileDTO, any>> {
    return this.httpClient?.get(`${this.url}/customer/${customerUuid}`,{headers: this.headers}).pipe(this.getDtoMapper());
  }

}
